import { Controller } from "@hotwired/stimulus";
import {
  BILLABLE_ACTIONS_USED_EVENT,
  billableActionsManageHref,
  formatBillableActionMeterLabelHtml,
} from "../utils/billableActionsMeter";

export default class extends Controller {
  static targets = ["label", "manage"];

  static values = {
    usage: Number,
    limit: Number,
    accountId: Number,
    websiteId: Number,
  };

  connect() {
    this.handleUsage = this.handleUsage.bind(this);
    document.addEventListener(BILLABLE_ACTIONS_USED_EVENT, this.handleUsage);
    this.render();
  }

  disconnect() {
    document.removeEventListener(BILLABLE_ACTIONS_USED_EVENT, this.handleUsage);
  }

  usageValueChanged() {
    this.render();
  }

  handleUsage(event) {
    const increment = Number(event.detail && event.detail.count) || 1;
    this.usageValue = this.usageValue + increment;
  }

  render() {
    const numericLimit = Number(this.limitValue);
    if (!numericLimit || numericLimit <= 0) {
      this.element.classList.add("hidden");
      return;
    }

    this.element.classList.remove("hidden");
    this.labelTarget.innerHTML = formatBillableActionMeterLabelHtml(
      this.usageValue,
      numericLimit
    );

    const manageHref = billableActionsManageHref(
      this.accountIdValue,
      this.websiteIdValue
    );
    if (manageHref && this.hasManageTarget) {
      this.manageTarget.href = manageHref;
      this.manageTarget.classList.remove("hidden");
    } else if (this.hasManageTarget) {
      this.manageTarget.classList.add("hidden");
    }
  }
}
